export const setCookie = (name, value, exDays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exDays * 24 * 24 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
};

export const getToken = () => {
    const cookie = decodeURIComponent(document.cookie);
    const array = cookie.split('=');
    return array[1];
};



// WEBPACK FOOTER //
// ./src/cookieStorage/CookieStorage.js